import { Component, OnInit, Input } from '@angular/core';
import { DICE_RENEWALS_CONFIG } from '../../../_common/product-config';
import { RenewalStatus, RenewalProductInstanceStatusGroup } from 'src/app/_common/_enum/module.enum';
import { RenewalsService } from '../../_services/renewals.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-product-instance',
  templateUrl: './product-instance.component.html',
  styleUrls: ['./product-instance.component.scss']
})
export class ProductInstanceComponent implements OnInit {
  @Input() expiringPolicies: any;
  @Input() renewalStatus: any;

  private piMessages = DICE_RENEWALS_CONFIG.PIMessages;
  private piGroupEnum = RenewalProductInstanceStatusGroup;
  private renewalStatusEnum = RenewalStatus;
  private todayDate = new Date();

  private isBindAvailable = false;
  

  constructor(private renewalsService: RenewalsService, private readonly route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    console.log('expiringPolicies :: ', this.expiringPolicies);
    console.log('renewalStatus :: ', this.renewalStatus);
    this.setIfBindIsAvailable();
  }

  downloadDocuments(_docObj, docName) {
    /* _docObj.accountNumber = 10096620;
    _docObj.id = 6664241; */

    _docObj.isDownloading = true;

    let documentDownloadSubscription = this.renewalsService.downloadDocuments(_docObj.accountNumber, _docObj.id, docName).subscribe(response => {
      _docObj.isDownloading = false;
    },
    error => {
      _docObj.isDownloading = false;
      this.renewalsService.openModal('error', 'none');
    });
    this.renewalsService.runningServices.push(documentDownloadSubscription);
  }

  openPolicyDetails(policyNumber){
    //this.accountService.storePolicyData(policy);
    this.router.navigateByUrl("policies/" + policyNumber);
  }

  setIfBindIsAvailable() {
    //let bindAvailable = false;
    this.isBindAvailable = null;
    this.expiringPolicies.forEach(policy => {
      if(policy.renewalProductInstance) {
        if(this.isBindAvailable != false && (policy.renewalProductInstance.productInstanceStatusGroup === 'Open' || policy.renewalProductInstance.productInstanceStatusGroup === 'Issued')){
          this.isBindAvailable = (policy.renewalProductInstance && policy.renewalProductInstance.documents.length > 0) && policy.renewalProductInstance.documents.some(_doc => _doc.docStatus === 'Posted' || _doc.documentTypeName == 'Binder');
        }
      }
    });

    if (this.isBindAvailable == null) this.isBindAvailable = false;
  }
}
